
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";

    @Component( {
        name: "Main",
        props: {},
        components: {}
    } )
    export default class Main extends Vue {

        constructor() {
            super();
        }

        public mounted() {

            this.$EventBus.$on( 'scroll-bottom', (x: 'auto' | 'smooth') => {
                document.documentElement.scrollTo( {
                    left: 0,
                    top: document.documentElement.scrollHeight - document.documentElement.clientHeight,
                    behavior: x
                } );
            } );

            let self = this;
            window.addEventListener( 'keydown', ( e ) =>
            {
                if ( e.key == 'F5' && e.ctrlKey && e.shiftKey )
                {
                    window.location.reload();
                }
                else if ( e.key.startsWith( 'F' ) && e.key.length > 1 && e.key != 'F12' )
                {
                    e.preventDefault();
                }
                else if ( e.ctrlKey && !['n','a','o','c', 'v', 'x'].includes( e.key) )
                {
                    e.preventDefault();
                }
                if ( e.ctrlKey && ['e','n', 'a', 'o'].includes( e.key ) )
                {
                    e.preventDefault();
                    e.stopPropagation();
                }
                else if ( e.altKey )
                {
                    e.preventDefault();
                }
                self.$EventBus.KeyDown( e );

            } );
            window.addEventListener( 'keyup', ( e: any ) =>
            {

                self.$EventBus.Teclas( e );
                self.$EventBus.KeyUp( e );
            } );
            window.document.body.onscroll = function ( Event: any ) { self.$EventBus.Scroll( Event ); };


        }
    }
